<template>
  <svg
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.3996 5.8H1.59961M9.39961 1V3.4M4.59961 1V3.4M5.19961 9.4L6.39961 10.6L9.09961 7.9M4.47961 13H9.51961C10.5277 13 11.0318 13 11.4168 12.8038C11.7555 12.6312 12.0308 12.3559 12.2034 12.0172C12.3996 11.6321 12.3996 11.1281 12.3996 10.12V5.08C12.3996 4.07191 12.3996 3.56786 12.2034 3.18282C12.0308 2.84413 11.7555 2.56876 11.4168 2.39619C11.0318 2.2 10.5277 2.2 9.51961 2.2H4.47961C3.47151 2.2 2.96747 2.2 2.58243 2.39619C2.24373 2.56876 1.96837 2.84413 1.7958 3.18282C1.59961 3.56786 1.59961 4.07191 1.59961 5.08V10.12C1.59961 11.1281 1.59961 11.6321 1.7958 12.0172C1.96837 12.3559 2.24373 12.6312 2.58243 12.8038C2.96747 13 3.47151 13 4.47961 13Z"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
